<template>
  <div class="component marquee" :data-direction="direction" data-viewport>
    <div class="marquee__inner">
      <div class="marquee__container">
        <span class="marquee__line" v-html="`${data.content.title}&nbsp;`"></span>
        <span class="marquee__line" v-html="`${data.content.title}&nbsp;`"></span>
        <span class="marquee__line" v-html="`${data.content.title}&nbsp;`"></span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MarqueeBlock',

  props: {
    data: {
      type: Object,
      required: true,
      default: () => {},
    },
    direction: {
      type: String,
      required: true,
      default: () => 'left',
    },
  },
};
</script>

<style lang="scss" scoped>
.marquee {
  padding: $vertical-padding $horizontal-padding;

  @include mq($until: ipadL) {
    padding: $mobile-vertical-padding $mobile-horizontal-padding;
  }

  &__inner {
    border-top: 1px solid $color-white;
    border-bottom: 1px solid $color-white;

    padding: 20px 0px;
    overflow: hidden;
  }

  &__container {
    width: 10000px;

    @at-root [data-direction="right"] & {
      transform: translateX(calc(-100% + 100vw));
    }
  }

  &__line {
    display: block;

    font-size: rem(120px);
    font-size: calc(120px * var(--rw));
    line-height: rem(120px);
    line-height: calc(120px * var(--rw));

    animation-play-state: paused;

    @at-root [data-direction="left"] & {
      float: left;
      animation: marquee-text-animation-left 10s infinite linear;
    }

    @at-root [data-direction="right"] & {
      float: right;
      animation: marquee-text-animation-right 10s infinite linear;
    }

    @at-root [data-in-viewport] & {
      animation-play-state: running;
    }
  }

  @keyframes marquee-text-animation-left {
    0% { transform: translate3d(0, 0, 0); }
    100% { transform: translate3d(-100%, 0, 0); }
  }

  @keyframes marquee-text-animation-right {
    0% { transform: translate3d(0, 0, 0); }
    100% { transform: translate3d(100%, 0, 0); }
  }
}
</style>
